import { createUrl } from '../lib/createUrl';

import type { RouteMetadataKeys } from '../config/metadataKeys';

type OnboardPageQueryParams = Partial<{
  redirectUrl?: string;
}>;

export const routes = createUrl({
  baseRoute: '',
  subRoutes: {
    bookingRequests: {
      baseRoute: '/booking-requests',
      subRoutes: {},
      title: '',
    },
    clients: {
      baseRoute: '/clients',
      subRoutes: {
        create: {
          baseRoute: '/create',
          subRoutes: {},
          title: '',
        },
        editClient: {
          baseRoute: '/edit/:id',
          params: {} as { id: string },
          subRoutes: {},
          title: '',
        },
      },
      title: '',
    },
    controlCenter: {
      baseRoute: '/control-center',
      subRoutes: {
        booking: {
          baseRoute: '/booking',
          subRoutes: {},
          title: '',
        },
        calendars: {
          baseRoute: '/calendars',
          subRoutes: {},
          title: '',
        },
        communicationChannels: {
          baseRoute: '/communication-channels',
          subRoutes: {},
          title: '',
        },
        contacts: {
          baseRoute: '/contacts',
          subRoutes: {},
          title: '',
        },
        profile: {
          baseRoute: '/profile',
          subRoutes: {},
          title: '',
        },
        services: {
          baseRoute: '/services',
          subRoutes: {
            create: {
              baseRoute: '/create',
              subRoutes: {},
              title: '',
            },
            editService: {
              baseRoute: '/edit/:id',
              params: {} as { id: string },
              subRoutes: {},
              title: '',
            },
          },
          title: '',
        },
        workplace: {
          baseRoute: '/workspace',
          subRoutes: {
            locations: {
              baseRoute: '/locations',
              subRoutes: {},
              title: '',
            },
            schedule: {
              baseRoute: '/schedule',
              subRoutes: {},
              title: '',
            },
          },
          title: '',
        },
      },
      title: '',
    },
    conversations: {
      baseRoute: '/conversations',
      subRoutes: {
        conversation: {
          baseRoute: '/:id',
          params: {} as { id: string },
          subRoutes: {},
          title: '',
        },
      },
      title: '',
    },
    home: {
      baseRoute: '/',
      subRoutes: {},
      title: '',
    },
    inbox: {
      baseRoute: '/inbox',
      subRoutes: {
        clients: {
          baseRoute: '/clients',
          subRoutes: {
            addClient: {
              baseRoute: '/add',
              subRoutes: {},
              title: '',
            },
            editClient: {
              baseRoute: '/:id',
              params: {} as { id: string },
              subRoutes: {},
              title: '',
            },
          },
          title: '',
        },
      },
      title: '',
    },
    newAppt: {
      baseRoute: '/newAppt',
      subRoutes: {
        clients: {
          baseRoute: '/clients',
          subRoutes: {},
          title: '',
        },
        confirm: {
          baseRoute: '/confirm',
          subRoutes: {},
          title: '',
        },
        services: {
          baseRoute: '/services',
          subRoutes: {
            adjust: {
              baseRoute: '/adjust',
              subRoutes: {},
              title: '',
            },
          },
          title: '',
        },
        time: {
          baseRoute: '/time',
          subRoutes: {},
          title: '',
        },
      },
      title: '',
    },
    onboard: {
      baseRoute: '/onboard',
      subRoutes: {
        bookingRules: {
          baseRoute: '/booking-rules',
          queryParams: {} as OnboardPageQueryParams,
          subRoutes: {},
          title: '',
        },
        communicationChannels: {
          baseRoute: '/communication-channels',
          queryParams: {} as OnboardPageQueryParams,
          subRoutes: {},
          title: '',
        },
        contacts: {
          baseRoute: '/contacts',
          queryParams: {} as OnboardPageQueryParams,
          subRoutes: {},
          title: '',
        },
        location: {
          baseRoute: '/location',
          queryParams: {} as OnboardPageQueryParams,
          subRoutes: {},
          title: '',
        },
        profile: {
          baseRoute: '/profile',
          queryParams: {} as OnboardPageQueryParams,
          subRoutes: {},
          title: '',
        },
        review: {
          baseRoute: '/review',
          queryParams: {} as OnboardPageQueryParams,
          subRoutes: {},
          title: '',
        },
        schedule: {
          baseRoute: '/schedule',
          queryParams: {} as OnboardPageQueryParams,
          subRoutes: {},
          title: '',
        },
        services: {
          baseRoute: '/services',
          queryParams: {} as OnboardPageQueryParams,
          subRoutes: {
            create: {
              baseRoute: '/create',
              subRoutes: {},
              title: '',
            },
            edit: {
              baseRoute: '/edit/:id',
              params: {} as { id: string },
              subRoutes: {},
              title: '',
            },
          },
          title: '',
        },
        sync: {
          baseRoute: '/sync',
          subRoutes: {},
          title: '',
        },
        welcome: {
          baseRoute: '/welcome',
          subRoutes: {},
          title: '',
        },
      },
      title: '',
    },
    schedule: {
      baseRoute: '/schedule',
      subRoutes: {},
      title: '',
    },
    subscription: {
      baseRoute: '/subscription',
      subRoutes: {},
      title: '',
    },
  },
  title: 'Tumli',
} as const);

export type ExtractUrls<T> =
  T extends { path: infer P extends string } ?
    | {
        [K in keyof T]: K extends RouteMetadataKeys ? never : ExtractUrls<T[K]>;
      }[keyof T]
    | P
  : never;

export type Urls = ExtractUrls<typeof routes>;
